import { z } from 'zod';

import { savedDocumentAttachment, zodSelectOption, zodWeapon } from '@/shared/lib/validations';

export const weaponSelectionSchema = z.object({
  weapon: z.union([z.null(), z.undefined(), zodWeapon]).superRefine((value, ctx) => {
    if (value === null || value === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Необхідно вибрати зброю',
      });
    }
  }),
  orgNpu: zodSelectOption.extend({ isPayable: z.boolean() }),
});

const weaponPhotoSchema = z.object({
  weaponRightPhoto: savedDocumentAttachment,
  weaponLeftPhoto: savedDocumentAttachment,
});

export const weaponSelectionSchemaWithPhoto = weaponSelectionSchema.merge(weaponPhotoSchema);
